import { b as A } from "./maps.DxC18PqJ.js";
import { i as C, b as c, r as n, a as m, f as Z } from "./debounce.BDLEW31m.js";
import { useDefaultStyles as rr } from "../p-components.useDefaultStyles.js";
var er = Array.isArray, tr = "[object AsyncFunction]", or = "[object Function]", ar = "[object GeneratorFunction]", nr = "[object Proxy]";
function F(r) {
  if (!C(r))
    return !1;
  var e = c(r);
  return e == or || e == ar || e == tr || e == nr;
}
var f = n["__core-js_shared__"], $ = function() {
  var r = /[^.]+$/.exec(f && f.keys && f.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function sr(r) {
  return !!$ && $ in r;
}
var ir = Function.prototype, cr = ir.toString;
function s(r) {
  if (r != null) {
    try {
      return cr.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
var ur = /[\\^$.*+?()[\]{}|]/g, pr = /^\[object .+?Constructor\]$/, fr = Function.prototype, gr = Object.prototype, yr = fr.toString, br = gr.hasOwnProperty, dr = RegExp(
  "^" + yr.call(br).replace(ur, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Tr(r) {
  if (!C(r) || sr(r))
    return !1;
  var e = F(r) ? dr : pr;
  return e.test(s(r));
}
function jr(r, e) {
  return r == null ? void 0 : r[e];
}
function u(r, e) {
  var o = jr(r, e);
  return Tr(o) ? o : void 0;
}
var y = u(n, "WeakMap"), mr = 9007199254740991;
function D(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= mr;
}
function lr(r) {
  return r != null && D(r.length) && !F(r);
}
var vr = Object.prototype;
function V(r) {
  var e = r && r.constructor, o = typeof e == "function" && e.prototype || vr;
  return r === o;
}
var Ar = "[object Arguments]";
function h(r) {
  return m(r) && c(r) == Ar;
}
var B = Object.prototype, $r = B.hasOwnProperty, hr = B.propertyIsEnumerable, wr = h(/* @__PURE__ */ function() {
  return arguments;
}()) ? h : function(r) {
  return m(r) && $r.call(r, "callee") && !hr.call(r, "callee");
};
function Or() {
  return !1;
}
var _ = typeof exports == "object" && exports && !exports.nodeType && exports, w = _ && typeof module == "object" && module && !module.nodeType && module, xr = w && w.exports === _, O = xr ? n.Buffer : void 0, Pr = O ? O.isBuffer : void 0, Sr = Pr || Or, Mr = "[object Arguments]", Er = "[object Array]", Ir = "[object Boolean]", kr = "[object Date]", Cr = "[object Error]", Fr = "[object Function]", Dr = "[object Map]", Vr = "[object Number]", Br = "[object Object]", _r = "[object RegExp]", Nr = "[object Set]", Ur = "[object String]", Rr = "[object WeakMap]", Gr = "[object ArrayBuffer]", Wr = "[object DataView]", zr = "[object Float32Array]", Lr = "[object Float64Array]", qr = "[object Int8Array]", Kr = "[object Int16Array]", Hr = "[object Int32Array]", Jr = "[object Uint8Array]", Xr = "[object Uint8ClampedArray]", Qr = "[object Uint16Array]", Yr = "[object Uint32Array]", t = {};
t[zr] = t[Lr] = t[qr] = t[Kr] = t[Hr] = t[Jr] = t[Xr] = t[Qr] = t[Yr] = !0;
t[Mr] = t[Er] = t[Gr] = t[Ir] = t[Wr] = t[kr] = t[Cr] = t[Fr] = t[Dr] = t[Vr] = t[Br] = t[_r] = t[Nr] = t[Ur] = t[Rr] = !1;
function Zr(r) {
  return m(r) && D(r.length) && !!t[c(r)];
}
function re(r) {
  return function(e) {
    return r(e);
  };
}
var N = typeof exports == "object" && exports && !exports.nodeType && exports, i = N && typeof module == "object" && module && !module.nodeType && module, ee = i && i.exports === N, g = ee && Z.process, x = function() {
  try {
    var r = i && i.require && i.require("util").types;
    return r || g && g.binding && g.binding("util");
  } catch {
  }
}(), P = x && x.isTypedArray, te = P ? re(P) : Zr;
function oe(r, e) {
  return function(o) {
    return r(e(o));
  };
}
var ae = oe(Object.keys, Object), ne = Object.prototype, se = ne.hasOwnProperty;
function ie(r) {
  if (!V(r))
    return ae(r);
  var e = [];
  for (var o in Object(r))
    se.call(r, o) && o != "constructor" && e.push(o);
  return e;
}
var b = u(n, "Map"), d = u(n, "DataView"), T = u(n, "Promise"), j = u(n, "Set"), S = "[object Map]", ce = "[object Object]", M = "[object Promise]", E = "[object Set]", I = "[object WeakMap]", k = "[object DataView]", ue = s(d), pe = s(b), fe = s(T), ge = s(j), ye = s(y), a = c;
(d && a(new d(new ArrayBuffer(1))) != k || b && a(new b()) != S || T && a(T.resolve()) != M || j && a(new j()) != E || y && a(new y()) != I) && (a = function(r) {
  var e = c(r), o = e == ce ? r.constructor : void 0, p = o ? s(o) : "";
  if (p)
    switch (p) {
      case ue:
        return k;
      case pe:
        return S;
      case fe:
        return M;
      case ge:
        return E;
      case ye:
        return I;
    }
  return e;
});
var be = "[object Map]", de = "[object Set]", Te = Object.prototype, je = Te.hasOwnProperty;
function me(r) {
  if (r == null)
    return !0;
  if (lr(r) && (er(r) || typeof r == "string" || typeof r.splice == "function" || Sr(r) || te(r) || wr(r)))
    return !r.length;
  var e = a(r);
  if (e == be || e == de)
    return !r.size;
  if (V(r))
    return !ie(r).length;
  for (var o in r)
    if (je.call(r, o))
      return !1;
  return !0;
}
function $e({
  tool: r,
  context: e,
  toolKind: o
}) {
  const {
    builderMode: p,
    defaultAssets: U,
    deviceViewport: l,
    firstVisitDate: R,
    actions: G,
    hotelTimezone: W,
    hotelTimezoneOffset: z,
    language: L,
    countdownTimestamp: q
  } = e;
  (me(r.theme.styles) || !r.theme.styles) && (r.theme.styles = rr(o));
  const {
    content: {
      modules: K
    },
    settings: {
      devices: v
    },
    theme: {
      styles: H
    }
  } = r, J = o !== A.Note ? r.settings.layout : void 0, X = o === A.Inliner ? r.settings.embedded : void 0, Q = v ? v[l].position : void 0, Y = {
    builderMode: p,
    firstVisitDate: R,
    hotelTimezone: W,
    hotelTimezoneOffset: z,
    defaultAssets: U,
    countdownTimestamp: q,
    tokens: r.tokens,
    dynamicTags: r.dynamicTags
  };
  return {
    language: L,
    device: l,
    position: Q,
    modules: K,
    layout: J,
    styles: H,
    actions: G,
    extraData: Y,
    embedded: X
  };
}
export {
  $e as p
};
//# sourceMappingURL=parseToolData.CdJg7fgv.js.map
